import { ABOUT_VALUES } from "#/lib/constants";
import { SectionLabel } from "#/components/shared/SectionLabel";
import { Icon } from "#/components/shared/Icon";
import { useScrollAnimation } from "#/hooks/useScrollAnimation";

/**
 * What we stand for. Dark band so it breaks up the two light sections around
 * it, matching how the home page alternates.
 */
export function AboutValues() {
  const { ref, isVisible } = useScrollAnimation(0.05);

  return (
    <section className="bg-graphite py-20 lg:py-28">
      <div ref={ref} className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <SectionLabel tone="light">How We Work</SectionLabel>
          <h2
            className={`mt-4 font-heading text-3xl font-extrabold leading-[1.1] text-white transition-all duration-700 sm:text-4xl lg:text-5xl ${
              isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"
            }`}
          >
            Six things you can hold us to.
          </h2>
          <p className="mt-5 leading-relaxed text-concrete-light">
            Every concrete company says it does good work. These are the
            specific promises you can check us against, before and after the
            pour.
          </p>
        </div>

        <div className="mt-14 grid gap-px overflow-hidden rounded-2xl bg-charcoal-light sm:grid-cols-2 lg:grid-cols-3">
          {ABOUT_VALUES.map((v, i) => (
            <div
              key={v.title}
              className={`bg-charcoal p-8 transition-all duration-500 ${
                isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"
              }`}
              style={{ transitionDelay: isVisible ? `${i * 70}ms` : "0ms" }}
            >
              <Icon name={v.icon} className="h-8 w-8 text-flame" />
              <h3 className="mt-5 font-heading text-xl font-bold text-white">
                {v.title}
              </h3>
              <p className="mt-2 leading-relaxed text-concrete-light">
                {v.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
